(function stickyNavBarButton(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousStickyNavBarButton = global.NewHomeSource.StickyNavBarButton;
  const stickyNav = document.querySelector('[data-sticky-nav-bar]');
  const stickyNavSensor = document.querySelector('[data-sticky-nav-bar-sensor]');
  const dataNavLinks = document.querySelector('[data-nav-links]');
  const rootMarginCalc = dataNavLinks ? ("-" + dataNavLinks.offsetHeight + "px") : "0px";

  function observerStickyNavBar() {
    if (!stickyNav || !stickyNavSensor) {
      return;
    }
    const options = {
      root: null,
      rootMargin: rootMarginCalc,
      threshold: 0
    };

    const observer = new IntersectionObserver(((entries) => {
      entries.forEach(entry => {
        const intersecting = entry.isIntersecting;
        if (!intersecting) {
          stickyNav.classList.add('nhs-n1-c-wrapper__sticky-nav-desktop--sticky');
        } else {
          stickyNav.classList.remove('nhs-n1-c-wrapper__sticky-nav-desktop--sticky');
        }
      });
    }),
    options
    );
    observer.observe(stickyNavSensor);
  }
  /**
   * @constructs NewHomeSource.StickyNavBarButton
   */
  function StickyNavBarButton() {
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.StickyNavBarButton to the previous script.
   */
  StickyNavBarButton.noConflict = function noConflict() {
    global.NewHomeSource.StickyNavBarButton = previousStickyNavBarButton;
    return StickyNavBarButton;
  };
  if (stickyNav !== null) {
    observerStickyNavBar();
  }
  global.NewHomeSource.StickyNavBarButton = StickyNavBarButton;
}(window));
